export const RENAME_THEME = 'RENAME_THEME'
export const SWITCH_BASE_THEME_LIGHT = 'SWITCH_BASE_THEME_LIGHT'
export const SWITCH_BASE_THEME_DARK = 'SWITCH_BASE_THEME_DARK'
export const UPDATE_BG_COLOR = 'CHANGE_BG_COLOR'
export const UPDATE_SYNTAX_COLOR = 'UPDATE_SYNTAX_COLOR'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js